import { render, staticRenderFns } from "./LockIcon.vue?vue&type=template&id=3ca59fcc&scoped=true&"
var script = {}
import style0 from "./LockIcon.vue?vue&type=style&index=0&id=3ca59fcc&prod&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca59fcc",
  null
  
)

export default component.exports